import { useState, useEffect, useCallback } from "react";
import { REGISTRATION_RULES_API, fetchWithAuth } from "../utils/api";

/**
 * Hook to fetch and manage available style categories from registration rules
 */
export function useStyleCategories() {
  const [styleCategories, setStyleCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchStyleCategories = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Fetch registration rules to get style categories
      const rulesData = await fetchWithAuth(REGISTRATION_RULES_API);
      
      // Extract style categories from registration rules
      const categoriesList = rulesData?.styleCategories || [];
      
      // Normalize style categories to get labels
      const normalizedCategories = categoriesList
        .map(category => {
          // Handle both string and object formats
          if (typeof category === 'string') {
            return category;
          }
          return category.label || category.name || category.value || '';
        })
        .filter(label => label && label.trim() !== "")
        .filter((label, index, arr) => arr.indexOf(label) === index) // Remove duplicates
        .sort(); // Sort alphabetically
      
      console.log('Fetched style categories from registration rules:', normalizedCategories);
      setStyleCategories(normalizedCategories);
    } catch (err) {
      console.error("Error fetching style categories:", err);
      setError(err.message || "Failed to load style categories");
      setStyleCategories([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // Load style categories on mount
  useEffect(() => {
    fetchStyleCategories();
  }, [fetchStyleCategories]);

  return {
    styleCategories,
    loading,
    error,
    refetchStyleCategories: fetchStyleCategories
  };
}






